import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';

const AsyncFavorites = Load(() => import(/* webpackChunkName: "favorites-page" */'./components/FavoritesPage'));
const AsyncFavoritesAdd = Load(() => import(/* webpackChunkName: "favorites-page" */'./components/FavoritesPageAdd'));

const FavoritesRoutes = [
  <NavigationableLayout
    key="favorites-add"
    path={`${basePath}/favorites/add/:experienceId`}
    component={AsyncFavoritesAdd}
    showBottomNavigation
    showSearchInNavbar
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="favorites"
    path={`${basePath}/favorites`}
    component={AsyncFavorites}
    showBottomNavigation
    showSearchInNavbar
    nonFixedNavbar
  />
];

export default FavoritesRoutes;
